import { defineMessages } from 'react-intl';

type MessageDescriptor = {
	id: string;
	defaultMessage: string;
	description: string;
};

export const messages: {
	expiredTitle: MessageDescriptor;
	expiredDescription: MessageDescriptor;
	logIn: MessageDescriptor;
	loginFailedTitle: MessageDescriptor;
	loginFailedDescription: MessageDescriptor;
	tryAgain: MessageDescriptor;
} = defineMessages({
	expiredTitle: {
		id: 'twg-microsite-experience.SessionFlags.expiredTitle',
		defaultMessage: 'Your session has expired',
		description:
			'Heading of a notification flag shown once when a signed-in visitor of the Teamwork Graph microsite is signed out because their session expired. "Teamwork Graph" is an Atlassian product name.',
	},
	expiredDescription: {
		id: 'twg-microsite-experience.SessionFlags.expiredDescription',
		defaultMessage: 'Log in again to keep using your graph.',
		description:
			'Body text of the session expired notification flag. "graph" here means the connected data structure of the visitor’s work entities and relationships shown by the Teamwork Graph microsite, not a chart. "Teamwork Graph" is an Atlassian product name.',
	},
	logIn: {
		id: 'twg-microsite-experience.SessionFlags.logIn',
		defaultMessage: 'Log in',
		description:
			'Button label on the session expired notification flag. Pressing it sends the visitor to the Atlassian login page and brings them back to the page they were on.',
	},
	loginFailedTitle: {
		id: 'twg-microsite-experience.SessionFlags.loginFailedTitle',
		defaultMessage: 'We couldn’t log you in',
		description:
			'Heading of a notification flag shown on the Teamwork Graph microsite when sending the visitor to the Atlassian login page has failed repeatedly. "Teamwork Graph" is an Atlassian product name.',
	},
	loginFailedDescription: {
		id: 'twg-microsite-experience.SessionFlags.loginFailedDescription',
		defaultMessage:
			'Something went wrong on the way to the login page. Try again, or clear your cookies for this site and reload if it keeps happening.',
		description:
			'Body text of the login failed notification flag on the Teamwork Graph microsite. "cookies" are browser cookies. "Teamwork Graph" is an Atlassian product name.',
	},
	tryAgain: {
		id: 'twg-microsite-experience.SessionFlags.tryAgain',
		defaultMessage: 'Try again',
		description:
			'Button label on the login failed notification flag. Pressing it starts the Atlassian login redirect once more.',
	},
});
